import { LinearGradient } from "@tamagui/linear-gradient";
export { LinearGradient };
//# sourceMappingURL=linear-gradient.mjs.map
